import { elevation } from '@atlaskit/theme';
import styled from '@emotion/styled';
import { FirstImpressionsImageUrlsType } from '../../../../../../model';

export const PageRoot = styled.div<{
  readonly firstImpressionsImageUrls: FirstImpressionsImageUrlsType;
}>`
  background-image: url(${(props) =>
    props.firstImpressionsImageUrls.backgroundImage});
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;

  @media only screen and (max-width: 769px) {
    background-size: auto;
  }
`;

export const PageBody = styled.div`
  flex: 1;
  max-width: 1440px;
  display: flex;
  align-items: flex-start;
  margin-top: 22px;
  margin-bottom: 60px;
  @media only screen and (max-width: 769px) {
    width: 100%;
    flex-flow: row wrap-reverse;
    justify-content: center;
  }
`;

export const LeftContainer = styled.div`
  margin: 16px;
  width: 448px;
  img {
    margin-bottom: 10px !important;
  }
`;

export const RightContainer = styled.div`
  ${elevation.e200}
  margin: 16px;
  padding: 32px;
  background-color: white;
  box-sizing: content-box;
  width: 350px;
  align-items: center;
  border-radius: 8px;
  position: relative;

  @media only screen and (max-width: 420px) {
    box-shadow: unset;
    margin: 0;
    border-radius: 0;
  }
`;

export const ChooseSignupRightContainer = styled.div`
  ${elevation.e200}
  margin: 16px;
  padding: 30px;
  background-color: white;
  box-sizing: content-box;
  width: 320px;
  align-items: center;
  border-radius: 8px;
  position: relative;

  @media only screen and (max-width: 420px) {
    box-shadow: unset;
    margin: 0;
    border-radius: 0;
  }
`;

export const RightContainerContent = styled.div`
  margin: 16px 0;
  width: 100%;
`;

export const RightContainerContentDefaultExpandedEmail = styled.div`
  margin: 16px 0;
  width: 100%;
`;

export const LogoWrapper = styled.div`
  width: min-content;
  margin: 0 auto;
`;

export const Loading = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;
